export default __webpack_public_path__ + "static/media/mobile-push-venue-data.9fbe2051.png";